export default function(level) {
  return function logger(...args) {
    /* eslint-disable no-console */
    if (console) {
      if (level === 'error' && console.error) {
        console.error.apply(null, args);
      } else if (process.env.NODE_ENV === 'development' && console[level]) {
        console[level].apply(null, args);
      }
    }
    /* eslint-enable */
  };
}



// WEBPACK FOOTER //
// ./src/main/logger.js